import type { FC } from 'react';
import { AppRoutes } from 'common/types';
import { safeReactLazy } from 'common/helpers/safe.import';

export interface Routes {
  component: FC;
  path: string;
}

const ClientDashboard = safeReactLazy(
  () => import('components/ClientDashboard/ClientDashboard'),
);

const Home = safeReactLazy(() => import('components/Home/Home'));
const Reservation = safeReactLazy(
  () => import('components/Reservation/Reservation'),
);
const Ecology = safeReactLazy(() => import('components/Ecology/Ecology'));
const Subscribe = safeReactLazy(
  () => import('components/Subscription/Subscribe'),
);
const Search = safeReactLazy(() => import('components/Search/Search'));
const EmailVerification = safeReactLazy(
  () => import('components/EmailVerification'),
);
const AbutUs = safeReactLazy(() => import('components/AboutUs/AboutUs'));
const ConfirmPayment = safeReactLazy(() => import('components/ConfirmPayment'));
export const MainRoutes: Array<Routes> = [
  {
    path: AppRoutes.CLIENT_DASHBOARD,
    component: ClientDashboard,
  },
  {
    path: AppRoutes.HOME,
    component: Home,
  },
  {
    path: AppRoutes.ABOUT_US,
    component: AbutUs,
  },
  {
    path: AppRoutes.RESERVATION,
    component: Reservation,
  },
  {
    path: AppRoutes.ECOLOGY,
    component: Ecology,
  },
  {
    path: AppRoutes.SUBSCRIBE,
    component: Subscribe,
  },
  {
    path: AppRoutes.SEARCH,
    component: Search,
  },
  {
    path: AppRoutes.EMAIL_VERIFICATION,
    component: EmailVerification,
  },
  {
    path: `${AppRoutes.CONFIRM_ORDER_PAYMENT}/:id`,
    component: ConfirmPayment,
  },
];
